import axios from "./axiosInstance";
const {
  REACT_APP_ENVIRONMENT,
  REACT_APP_SERVER_URL,
  REACT_APP_TESTS_SERVER_URL,
} = process.env;

const nonSandboxRoutes = ["/neap-tests"];

function apiRequest(props) {
  const { url, init, query, option, config } = props;
  const isNonSandboxRoute = nonSandboxRoutes.some((route) =>
    url.includes(route)
  );

  const serverUrl = isNonSandboxRoute
    ? REACT_APP_TESTS_SERVER_URL
    : REACT_APP_SERVER_URL;

  const basePath =
    isNonSandboxRoute || REACT_APP_ENVIRONMENT !== "sandbox"
      ? "/internal"
      : `/sandbox/internal`;

  const urlWithBasePath = `${serverUrl}${basePath}${url}`;

  if (init.method === "POST") {
    return axios.post(urlWithBasePath, option, config);
  }
  if (init.method === "PATCH") {
    return axios.patch(urlWithBasePath, option);
  }
  if (init.method === "DELETE") {
    return axios.delete(urlWithBasePath, { data: option });
  }
  return axios.get(urlWithBasePath, { params: option });
}

const request = {
  get: (url, option) =>
    apiRequest({
      url,
      init: {
        method: "GET",
      },
      option,
    }),

  delete: (url, option) =>
    apiRequest({
      url,
      init: {
        method: "DELETE",
      },
      option,
    }),

  post: (url, option, config) =>
    apiRequest({
      url,
      init: {
        method: "POST",
      },
      option,
      config,
    }),
  patch: (url, option) =>
    apiRequest({
      url,
      init: {
        method: "PATCH",
      },
      option,
    }),
};

export default request;
